import { Clipboard } from '@angular/cdk/clipboard';
import { Component, Input, OnInit } from '@angular/core';
import { Banner } from 'src/app/model/shared/banner';
import { PageVersion } from 'src/app/model/shared/page-version';
import { PageVersionService } from 'src/app/service/page-version.service';
import { SharedDataService } from 'src/app/service/shared-data.service';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {
  @Input() banner: Banner = {} as Banner;
  @Input() isHomePage: boolean = false;
  @Input() isRevisionNoticesPage: boolean = false;
  @Input() isAPIDocsBanner: boolean = false;
  @Input() isIAGModuleBanner: boolean = false;
  @Input() isCommonBanner: boolean = false;
  @Input() isSearchBanner: boolean = false;
  @Input() isDefaultPageBanner: boolean = true;
  @Input() isWelcomeUserBanner: boolean = false;
  @Input() userName: string = '';
  @Input() isNewAPIRefBanner: boolean = false;
  selectedPageVersion: string = '';

  constructor(private clipboard: Clipboard, private sharedDataService: SharedDataService, private pageVersionService: PageVersionService) {}

  ngOnInit(): void {
    this.sharedDataService.sharedData.subscribe((banner) => {
      this.banner = banner;
      if ((this.banner.pageVersions || []).length > 0) {
        this.selectedPageVersion = banner.defaultPageVersion;
      }
    });
  }

  copyLink(url: string) {
    var host: string = window.location.protocol + '//' + window.location.host;
    this.clipboard.copy(host + url);
  }

  changePageVersion(selection: any) {
    let pageVersion: PageVersion = {} as PageVersion;
    pageVersion.pageName = this.banner.pageName || '';
    pageVersion.selectedPageVersion = selection.target.value;
    // console.log('sending selection : ', pageVersion);
    this.pageVersionService.addPageVersionData(pageVersion);
  }
}
